import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import { t } from '../utils/translations';
import { ShieldCheck, CheckCircle2 } from 'lucide-react';
export function Guarantee() {
  const {
    lang
  } = useLanguage();
  const text = t[lang].guarantee;
  return <section className="py-24 bg-mf-red text-white relative overflow-hidden" data-id="element-299">
      {/* Modern animated background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-300">
        <motion.div animate={{
        scale: [1, 1.2, 1],
        opacity: [0.3, 0.5, 0.3]
      }} transition={{
        duration: 8,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gradient-to-tr from-red-600 to-orange-500 rounded-full blur-[100px] opacity-40 mix-blend-screen" data-id="element-301"></motion.div>
        <div className="absolute inset-0 opacity-[0.05]" style={{
        backgroundImage: 'radial-gradient(#FFFFFF 2px, transparent 2px)',
        backgroundSize: '40px 40px'
      }} data-id="element-302"></div>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-303">
        <motion.div initial={{
        opacity: 0,
        scale: 0.5
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 200,
        damping: 20
      }} className="relative inline-flex items-center justify-center w-32 h-32 mb-10 group" data-id="element-304">
          {/* Pulsing rings */}
          <div className="absolute inset-0 bg-white/20 rounded-full animate-ping" style={{
          animationDuration: '3s'
        }} data-id="element-305"></div>
          <div className="absolute inset-2 bg-white/40 rounded-full animate-ping" style={{
          animationDuration: '3s',
          animationDelay: '0.5s'
        }} data-id="element-306"></div>

          <div className="relative w-full h-full bg-white text-mf-red rounded-full flex items-center justify-center shadow-[0_0_50px_rgba(255,255,255,0.3)] z-10" data-id="element-307">
            <ShieldCheck size={64} strokeWidth={1.5} data-id="element-308" />
          </div>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        type: 'spring',
        stiffness: 100,
        damping: 15
      }} className="text-5xl md:text-7xl font-condensed font-black uppercase tracking-tight mb-6 drop-shadow-lg" data-id="element-309">
          {text.title}
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1,
        type: 'spring',
        stiffness: 100,
        damping: 15
      }} className="text-2xl md:text-3xl font-medium text-white/90 mb-16 max-w-2xl mx-auto" data-id="element-310">
          {text.sub}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2,
        type: 'spring',
        stiffness: 100,
        damping: 15
      }} className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-8" data-id="element-311">
          {text.items.map((item, index) => <motion.div key={index} whileHover={{
          scale: 1.05,
          backgroundColor: 'rgba(255,255,255,0.2)'
        }} className="flex items-center bg-white/10 backdrop-blur-md border border-white/20 px-8 py-4 rounded-2xl shadow-xl transition-colors duration-300 w-full md:w-auto" data-id="element-312">
              <CheckCircle2 className="text-mf-yellow mr-4 flex-shrink-0" size={28} data-id="element-313" />
              <span className="font-bold text-xl tracking-wide" data-id="element-314">{item}</span>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}